import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import QRCode from "react-qr-code";
import { Calendar, MapPin, User, Loader2, Printer } from "lucide-react";

const apiBase = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TicketView() {
  const { ticketId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${apiBase}/public/tickets/${ticketId}`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(e.response?.data?.detail || "Billet introuvable"));
  }, [ticketId]);

  if (err) return (
    <div className="min-h-screen bg-[#F4F5F7] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-8 text-center">
        <p className="font-bold text-[#C62828]">{err}</p>
      </div>
    </div>
  );

  if (!data) return (
    <div className="min-h-screen bg-[#F4F5F7] flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-[#0A4628]" />
    </div>
  );

  const { ticket, event, club, category } = data;
  const primary = club.primary_color || "#9E1B1B";
  const isScanned = !!ticket.scanned_at;

  return (
    <div className="min-h-screen bg-[#F4F5F7] flex items-center justify-center p-4 print:bg-white print:p-0">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl overflow-hidden border border-[#E0E0E0] print:shadow-none" data-testid="ticket-view">
        <div className="p-6 text-white" style={{ background: `linear-gradient(135deg, ${primary} 0%, #121212 100%)` }}>
          <p className="text-[10px] tracking-[0.18em] uppercase opacity-80">Billet électronique</p>
          <h1 className="font-display text-2xl font-extrabold mt-1">{club.name}</h1>
          <p className="text-sm opacity-85 mt-1">{event.name}</p>
        </div>

        <div className="p-6 space-y-3">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2 text-[#616161]">
              <Calendar className="w-4 h-4" />
              {new Date(event.starts_at).toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" })}
            </div>
          </div>
          {event.venue && (
            <div className="flex items-center gap-2 text-sm text-[#616161]">
              <MapPin className="w-4 h-4" /> {event.venue}
            </div>
          )}
          <div className="flex items-center gap-2 text-sm text-[#616161]">
            <User className="w-4 h-4" /> {ticket.buyer_name}
          </div>

          <div className="border-t border-dashed border-[#E0E0E0] my-4" />

          <div className="text-center">
            <div className="inline-block p-3 bg-white border border-[#E0E0E0] rounded-md">
              <QRCode value={ticket.code} size={180} />
            </div>
            <p className="font-mono text-lg font-bold mt-3 tracking-wider" style={{ color: primary }}>{ticket.code}</p>
            <div className="flex items-center justify-center gap-2 mt-2">
              <span className="text-xs px-2 py-0.5 rounded font-semibold" style={{ background: `${primary}22`, color: primary }}>
                {category.name}
              </span>
              <span className="text-xs text-[#616161]">{(category.price_xof || 0).toLocaleString("fr-FR")} FCFA</span>
            </div>
          </div>

          {isScanned && (
            <div className="bg-[#C62828]/10 border border-[#C62828]/30 rounded p-3 text-center" data-testid="ticket-scanned">
              <p className="text-xs font-bold text-[#C62828] uppercase tracking-wider">⚠ Billet déjà utilisé</p>
              <p className="text-[11px] text-[#C62828] mt-1">Scanné le {new Date(ticket.scanned_at).toLocaleString("fr-FR")}</p>
            </div>
          )}

          <button
            onClick={() => window.print()}
            className="w-full mt-4 py-2 rounded-md text-white font-semibold flex items-center justify-center gap-2 print:hidden"
            style={{ background: primary }}
            data-testid="print-ticket-btn"
          >
            <Printer className="w-4 h-4" /> Imprimer ce billet
          </button>
        </div>

        <div className="border-t border-[#E0E0E0] px-6 py-3 text-center text-[10px] text-[#9E9E9E]">
          Ce billet est personnel et non cessible. Présentez le QR code à l&apos;entrée.
        </div>
      </div>
    </div>
  );
}
